import { useSuspenseQuery } from '@tanstack/react-query'

import { GetPlantasBlocoService } from '@/features/proposta/brasil/http'
import { plantasKeys } from '@/utils/plantas-query-keys'

export const useSuspensePlantasBloco = (idExternoBloco: number) => {
  return useSuspenseQuery({
    queryKey: plantasKeys.listaPorBloco(idExternoBloco),
    queryFn: async () => new GetPlantasBlocoService().execute(idExternoBloco).then((res) => res.data),
  })
}
